/* app/views/bento-box.js
Bento Box App Bento Box Views
*/

import $ from 'jquery';
import _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import ImagesLoaded from 'imagesloaded';
import EventChannel from '../events.js';
import * as Config from '../config.js';
import * as Utils from '../utils.js';
import defaultContentTemplate from '../../templates/content/default.html';
import bestBetTemplate from '../../templates/content/best-bet.html';
import exactCourseTemplate from '../../templates/content/exact-course.html';
import bottomLinksTemplate from '../../templates/content/bottom-links.html';
import boxesContainerTemplate from '../../templates/content/boxes-container.html';
import boxContainerTemplate from '../../templates/content/box-container.html';
import { BaseView, ContainerView } from './base.js';


function selectBox(selectedId) {
  /* Toggles classes to "select" only the bento box with the given id. */
  const sbClasses = 'text-bg-warning bg-opacity-10';
  $('.bento-box-inner').removeClass(sbClasses);
  if (selectedId) {
    $(`#${selectedId}`).addClass(sbClasses);
  }
}


const Default = BaseView.extend({
  /* The default content view that displays before you've searched. */
  template: _.template(defaultContentTemplate),
  renderEventLabel: 'bento-box-layout-rendered',
});


const BestBet = BaseView.extend({
  /* Displays only if Articles returns a best bet. */
  template: _.template(bestBetTemplate),
  collection: Config.boxes.articles.collection,
  renderEventLabel: 'best-bet-rendered',

  isNeeded: function(vars) {
    return Boolean(this.collection.bestBet);
  },

  prepVars: function(vars) {
    return _.extend({}, vars, {
      bestBet: this.collection.bestBet,
    });
  },
});


const ExactCourse = BaseView.extend({
  /* Displays only if Courses returns an exact course match. */
  template: _.template(exactCourseTemplate),
  collection: Config.boxes.courses.collection,

  isNeeded: function(vars) {
    return Boolean(this.collection.exactMatches);
  },

  prepVars: function(vars) {
    let exactMatch = this.collection.exactMatches[0];
    return _.extend({}, vars, {
      courseUrl: exactMatch.courseUrl,
      course: exactMatch.course,
      sections: exactMatch.sections.map(
        (sec) => `<a href="${sec.url}">${sec.instructor || "All Instructors"}</a>`
      ).join(', '),
    });
  },
});


const BottomLinks = BaseView.extend({
  /* View for "other searches" links at the bottom of the screen. */
  template: _.template(bottomLinksTemplate),
  identifier: 'other-searches',
  renderEventLabel: 'bento-box-rendered',

  prepVars: function(vars) {
    return _.extend(vars, {
      bottomLinks: Config.otherSearchesLinks(vars.qEncoded),
      boxId: this.identifier,
    });
  }
});


const BoxesContainer = ContainerView.extend({
  /* Container view for the bento boxes display. It controls which
   * boxes appear and their layout. */
  template: _.template(boxesContainerTemplate),
  boxContainer: _.template(boxContainerTemplate),
  subViewHook: '.bento-box-outer',
  renderEventLabel: 'bento-box-layout-rendered',
  boxPicker: Config.boxesDisplay,
  getWindowCols: Config.getWindowCols,
  columnClasses: {
    1: 'col-lg-12',
    2: 'col-lg-6',
    'default': 'col-md-6 col-lg-4',
  },

  initialize: function(options) {
    this.boxLayouts = {};
    this.currentLayout = {};
    this.listenTo(EventChannel, 'changed-columns', this.reOrderBoxes);
  },

  initBoxes: function(boxNames, includeAll) {
    this.boxLayouts = this.boxPicker.do(boxNames, includeAll);
  },

  setBoxLayout: function() {
    const boxes = this.boxLayouts[this.getWindowCols()];
    const columnClass = this.columnClasses[boxes.length];
    this.currentLayout = {
      boxes: boxes,
      columnClass: columnClass || this.columnClasses.default
    };
  },

  initSubViews: function(vars) {
    this.setBoxLayout();
    return this.currentLayout.boxes.map((box) => new BentoBox(box));
  },

  reOrderBoxes: function() {
    this.render(this.vars);
  },

  prepVars: function(vars) {
    this.query = vars.qDisplay;
    this.vars = vars;
    return vars;
  },

  getSubViewHook: function(vars, subView, container) {
    let subContainer = $(this.boxContainer({columnClass: this.currentLayout.columnClass}));
    container.append(subContainer);
    return subContainer.find(this.subViewHook);
  },

});


const BentoBox = ContainerView.extend({
  /* View for one bento box, which contains children views for results. */
  renderEventLabel: 'bento-box-rendered',
  subViewContainerHook: '.results .results-list',
  states: Config.boxStates,

  initialize: function(options) {
    this.box = options;
    this.identifier = this.box.code;
    this.template = this.box.templates.boxContainer;
    this.collection = this.box.collection;
    this.collection.listenTo(EventChannel, 'search', this.collection.doSearch); 
    if (!this.box.searchEnabled) {
      this.collection.disableSearch();
    }
    this.listenTo(
      EventChannel,
      `bento-box-collection-success:${this.collection.type}`,
      (vars) => {
        this.box.state = this.states.getResultState(this.box);
        this.activate(vars);
      },
    );
    this.listenTo(
      EventChannel,
      `bento-box-collection-error:${this.collection.type}`,
      (vars) => {
        this.box.state = this.states.error;
        this.activate(vars);
      },
    );
  },

  reset: function() {
    this.box.state = this.states.getStartingState(this.box);
    ContainerView.prototype.reset(this);
  },

  initSubViews: function(vars) {
    if (this.box.state == this.states.results) {
      return this.collection.models.map((model, i) => new Result({
        label: this.box.label,
        model: model,
        template: this.box.templates.result,
        identifier: `${this.identifier}${i}`,
      }));
    }
    return [];
  },

  prepVars: function(vars) {
    const trunc = this.identifier == 'librarian' && this.box.state === this.states.results ? 3 : 0;
    const qDisp = Utils.prepQueryForDisplay(vars.q, trunc);
    const newUrl = this.collection.newSearchUrl || this.box.defaultNewSearchUrl || '';
    let moreUrl = this.collection.fullResultsUrl || this.box.defaultFullResultsUrl || '';
    moreUrl = moreUrl.replace(/%QUERY%/, vars.qEncoded);
    const moreLabel = this.box.fullResultsLabel.replace(/%QUERY%/, `<em>${qDisp}</em>`);
    vars = _.extend({}, vars, {qDisplay: qDisp, boxId: this.identifier, label: this.box.label});
    return _.extend({}, vars, {
      buttons: this.states.makeButtons(
        {new: this.box.templates.newSearchButton, more: this.box.templates.moreResultsButton},
        {new: newUrl, more: moreUrl},
        {new: this.box.newSearchLabel, more: moreLabel},
        this.box.state
      ),
      stateMessage: this.box.state.stateMessage(vars, this.box),
      infoMessage: this.box.state.infoMessage(vars, this.box),
    });
  },

  getSubViewHook: function(vars, subView, container) {
    let subViewContainer = $(this.box.templates.resultContainer(vars));
    container.find(this.subViewContainerHook).append(subViewContainer);
    return subViewContainer;
  },

  prepContainer: function(vars, container) {
    container = ContainerView.prototype.prepContainer(vars, container, this);
    ImagesLoaded(container).on('progress', () => {
      Utils.layout.update();
      Utils.layout.jumpToElement();
    });
    /* This should fix an annoying issue on mobile where touching a link that
     * also has a BS tooltip causes the tooltip to persist when you go back.
     * Now it should just hide the tooltip when you touch it. */
    container.find('a[data-bs-toggle="tooltip"]').on('click', (ev) => {
      let $el = $(ev.currentTarget);
      Bootstrap.Tooltip.getInstance($el[0]).hide();
    });
    return container;
  },
});


const Result = BaseView.extend({
  /* View for one bento box result. The template to use is passed to
   * the initialization method, and the data is pulled from the model
   * and passed to the template (on "vars") during rendering. */
  events: {
    'click h4 a': 'clickedTitle',
    'contextmenu h4 a': 'rightClickedTitle',
    'click a.btn.externalLink': 'clickedGetItButton',
    'contextmenu a.btn.externalLink': 'rightClickedGetItButton',
    'click .reportBrokenLink': 'showBrokenLinkModal',
    'click .modal button.close': 'hideBrokenLinkModal',
  },

  initialize: function(options) {
    this.label = options.label;
    this.identifier = options.identifier;
    this.template = _.template(options.template);
    this.modal = null;
  },

  prepVars: function(vars) {
    vars = _.extend(this.model.attributes);
    if (vars.summary && vars.summary.length >= Config.maxSummaryLength) {
      vars.summary = Utils.truncateText(vars.summary, Config.summaryTruncatePoint);
    }
    if (vars.title && vars.title.length >= Config.maxSummaryLength) {
      vars.title = Utils.truncateText(vars.title, Config.titleTruncatePoint);
    }
    let linkId = encodeURIComponent(`untlbb-${vars.q}-${vars.title}-${this.identifier}`);
    return _.extend({}, vars, {
      resultId: this.identifier,
      linkId: linkId,
      itemVisited: sessionStorage.getItem(linkId) == 'visited',
      typeInfo: Utils.getTypeInfo(vars),
    });
  },

  showBrokenLinkModal: function(ev) {
    ev.preventDefault();
    let $el = $(ev.currentTarget);
    let id = `#modal-${$el.attr('id')}`;
    let href = $el.attr('href');
    if (Config.isMobile()) {
      window.open(href);
    } else {
      let $iframe = $(`${id} iframe`);
      if (!$iframe.attr('src')) {
        $iframe.attr('src', href);
      }
      this.modal = new Bootstrap.Modal($(id)[0], {keyboard: true});
      this.modal.show();
    }
    EventChannel.trigger(
      `broken-link-button-clicked:${this.identifier}`,
      {'label': this.label}
    );
  },

  hideBrokenLinkModal: function(ev) {
    this.modal.hide();
  },

  externalLinkAction: function(ev, preventDefault, evChannelEventName) {
    if (preventDefault) {
      ev.preventDefault();
    }
    sessionStorage.setItem($(ev.currentTarget).attr('data-id'), 'visited');
    this.$el.find('.btn.reportBrokenLink').removeClass('d-none');
    Utils.layout.update();
  },

  clickedTitle: function(ev) {
    this.externalLinkAction(ev, false, 'item-title-clicked');
  },

  clickedGetItButton: function(ev) {
    this.externalLinkAction(ev, false, 'item-button-clicked');
  },

  rightClickedTitle: function(ev) {
    this.externalLinkAction(ev, false, 'item-title-right-clicked');
  },

  rightClickedGetItButton: function(ev) {
    this.externalLinkAction(ev, false, 'item-button-right-clicked');
  }
});


export {
  selectBox,
  Default,
  BestBet,
  ExactCourse,
  BottomLinks,
  BoxesContainer,
  BentoBox,
  Result,
};
